import ProgressScale from "../Components/UI/ProgressScale";
import "chart.js/auto";
import StyledButton from "../Components/UI/StyledButton";
import ReactLoading from "react-loading";
import { useEffect, useState } from "react";
import TestApi from "../Api/TestApi";
import TestBlock from "../Components/Modules/Test/TestBlock";
import FinalPopUp from "../Components/Modules/Test/FinalPopUp";
import CertificatForm from "../Components/Modules/CertificatForm/CertificatForm";

const CertificatTestPage = () => {
  const courseInfo = JSON.parse(localStorage.getItem("courseInfo") || "[]");
  const [certificatOpen, setCertificatOpen] = useState(false);
  const [unlockNext, setUnlockNext] = useState(false);
  const [loader, setLoader] = useState(false);
  const [questionData, setQuestionData] = useState(
    JSON.parse(localStorage.getItem("question") || "{}") || null
  );
  const [chosenAnswerID, setChosenAnswerID] = useState([]);
  const [finalOpen, setFinalOpen] = useState(false);
  const [testCount, setTestCount] = useState(
    Number(localStorage.getItem("test_count")) || 1
  );
  const maxScore = JSON.parse(localStorage.getItem("maxScore") || "0");
  const [score, setScore] = useState(0);
  // const [passed, setPassed] = useState(false);

  async function onNextTest() {
    const data = {
      session_code: localStorage.getItem("session_code") || "",
      question_id: questionData.question.id,
      selected_answer_ids: chosenAnswerID,
    };

    setLoader(true);
    const nextTest = await TestApi.nextTest(data);

    setScore(nextTest.scores[0].category_score);

    if (nextTest.message === "Quiz completed") {
      const percent = (score / maxScore) * 100;

      if (percent > 60) {
        setCertificatOpen(true);
      } else {
        setFinalOpen(true);
        // setPassed(false);
      }
    } else if (nextTest.status === 200) {
      localStorage.setItem("question", JSON.stringify(nextTest.data));

      setTestCount(testCount + 1);
      setQuestionData(nextTest.data);

      setLoader(false);
    }
  }

  useEffect(() => {
    localStorage.setItem("test_count", JSON.stringify(testCount));
  }, [testCount]);

  return (
    <div className="coursesListPage">
      <div className="test">
        <div className="headTestBlock">
          <div className="courseBlockText testBlockText">
            <div>
              <h1>Тест на сертификат</h1>
              <div className="headCourseBlockDescription">
                Пройдите тестирование, чтобы получить сертификат, подтверждающий
                прохождение курса. На прохождение тестирования дается три
                попытки, затем результаты будут сброшены.
              </div>
            </div>
            <div className="moduleScaleBox">
              <span>
                Прохождение теста: {testCount} вопросов из{" "}
                {localStorage.getItem("total_question")}
              </span>
              <ProgressScale
                scale={
                  (testCount / Number(localStorage.getItem("total_question"))) *
                  100
                }
              />
            </div>
          </div>
        </div>

        <TestBlock
          question={questionData.question}
          answerList={questionData.answers}
          chosen={(e: boolean) => setUnlockNext(e)}
          chosenAnswerID={(e: any) => setChosenAnswerID(e)}
        />
        <div className="nextTestBox">
          {loader ? (
            <div>
              <ReactLoading
                type="spinningBubbles"
                color="black"
                height={"50px"}
                width={"50px"}
              />
            </div>
          ) : (
            <StyledButton
              text="ОТВЕТИТЬ"
              className={
                unlockNext ? "blueButton" : "greyButton disabledButton"
              }
              onClick={unlockNext ? () => onNextTest() : null}
            />
          )}
        </div>
      </div>

      {finalOpen && (
        <FinalPopUp
          message={
            "Тестирование на сертификат завершено. У Вас не хватило баллов для получения сертификата. Осталось 2 попытки, чтобы пройти тестирование."
          }
        />
      )}

      {certificatOpen && (
        <CertificatForm
          course={courseInfo.head}
          certificat_hours={courseInfo.certificat_hours}
          close={(e: boolean) => {
            setCertificatOpen(e);
          }}
        />
      )}
    </div>
  );
};

export default CertificatTestPage;
